module.exports = __webpack_public_path__ + "img/plus-or-minus.be016c64.svg";